import { NextSeo } from 'next-seo'

import { STOREFRONT_NAME } from '@/shared/consts'

interface BaseSeoProps {
  title?: string;
  description?: string;
  image?: string;
}

export function BaseSeo({ title, description, image }: BaseSeoProps) {
  const seoTitle = title ? `${title} - ${STOREFRONT_NAME}` : STOREFRONT_NAME
  const seoDescription = description || ''

  const ogImages = image
    ? [{ url: image, alt: title || STOREFRONT_NAME }]
    : [
      {
        url: 'https://www.pixieworldstore.com/static/og-image.png',
        width: 1200,
        height: 630,
        alt: 'PixieWorld',
      },
    ]

  return (
    <NextSeo
      title={seoTitle}
      description={seoDescription}
      openGraph={{
        title: seoTitle,
        description: seoDescription,
        images: ogImages,
        site_name: STOREFRONT_NAME,
      }}
    />
  )
}
